export function warmupFrom(race) {
  const m = /^(\d{1,2}):(\d{2})$/.exec((race || "").trim());
  if (!m) return "";
  const t = (((parseInt(m[1], 10) * 60 + parseInt(m[2], 10) - 20) % 1440) + 1440) % 1440;
  return `${String(Math.floor(t / 60)).padStart(2, "0")}:${String(t % 60).padStart(2, "0")}`;
}
